// import modules
import Utils      from 'Utils';
import Slick      from 'modules/Slick';
import ScrollTo   from 'modules/ScrollTo';
import HeightLine from 'modules/HeightLine';
import Validation from 'modules/Validation';

// DOM Ready
$(() => {
  // slick
  new Slick();

  // スムーズスクロール
  new ScrollTo();

  // 高さ揃え
  new HeightLine();

  // バリデーション
  new Validation();
});



// WEBPACK FOOTER //
// ./src/js/main.js